<template>
  <router-view />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

/**
 * Purposefully left as a generic router view.
 *
 * Allows us to route to ParentRouterViewPlatform.vue or ParentRouterViewPdf.vue depending on the route.
 */
export default defineComponent({
  name: 'AppEntry',
  setup() {
    return {};
  },
});
</script>
